<template>
  <div class="swiperPage" :style="pageStyle">
    <swiper
      :options="swiperOptions"
      ref="mySwiper"
      class="detailWrapper"
      @slideChange="onSlideChange">
      <swiper-slide v-for="item in itemIndex" :key="item">
        <div class="contentPage">
          <Detail
            :locale="locale"
            :lang="lang"
            :categoryId="categoryId"
            :collectionItemId="collectionItemId"
            :isCollectableUser="isCollectableUser"
            class="collectionItemDetail" />
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import Detail from './Detail'

export default {
  name: 'CollectionDetail',
  props: [
    'locale',
    'lang',
    'categoryId',
    'collectionItemId',
    'isCollectableUser'
  ],
  components: {
    swiper,
    swiperSlide,
    Detail
  },
  computed: {
    pageId () {
      return this.$route.params.pageId
    },
    pageFrame () {
      const frame = this.$store.getters['collection/getPageFrame']
      return frame ? `${frame}px` : ''
    },
    pageStyle () {
      const frame = this.pageFrame
      return {
        ...frame && {
          ...!this.isMainPage && {
            paddingTop: frame,
          },
          paddingLeft: frame,
          paddingRight: frame,
          paddingBottom: frame,

        },
      }
    }
  },
  created () {
    this.setItemIndex()
    this.$store.dispatch('collection/getMyCollectionItems', { pageId: this.pageId })
  },
  data () {
    return {
      itemIndex: [],
      swiperOptions: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        loop: false,
        autoplay: false,
        initialIndex: 0,
        threshold: 80
      }
    }
  },
  methods: {
    setItemIndex () {
      const getCategoryById = this.$store.getters['collection/getCategoryById'](this.categoryId)
      const indexArray = (getCategoryById && getCategoryById.collectionItemIndex) || [this.collectionItemId]
      const initialIndex = indexArray.indexOf(this.collectionItemId)

      this.itemIndex = indexArray
      this.swiperOptions.initialSlide = initialIndex >= 0 ? initialIndex : 0
    },
    onSlideChange () {
      const swiperInstance = this.$refs.mySwiper.swiper
      const idx = swiperInstance.activeIndex
      const newId = this.itemIndex[idx]
      // 라우터 파라미터 변경 (detailId만 변경)
      if (newId !== this.collectionItemId) {
        this.$router.push({
          params: { 
            ...this.$route.params,
            collectionItemId: newId
          }
        })
      }
    },
    collectItem (item) {
      console.log(item.collectionItemId)
    }
  }
}
</script>
